import { GridCellParams, GridValidRowModel } from '@mui/x-data-grid-pro'
import Pill, { PillProps } from 'ext-ui/components/Pill/Pill'
import React, { ReactElement } from 'react'
import DataGridCellWrapper from 'src/components/DataGrid/cells/DataGridCellWrapper/DataGridCellWrapper'

type PillCellProps<Row extends GridValidRowModel> = PillProps & {
  disabled?: boolean
  children: string | ReactElement
  params: GridCellParams<Row>
  'data-status'?: string
}

const PillCell = <Row extends GridValidRowModel>(
  props: PillCellProps<Row>,
): React.ReactElement => {
  const {
    disabled,
    children,
    params,
    'data-status': dataStatus,
    ...pillProps
  } = props
  return (
    <DataGridCellWrapper
      disabled={disabled}
      params={params}
      data-status={dataStatus}
    >
      <Pill {...pillProps}>{children}</Pill>
    </DataGridCellWrapper>
  )
}

export default PillCell
